import * as React from 'react';
import { Link } from 'react-router-dom';
import { ArticleType } from '../../models/article.model';
import { Button, Card } from 'react-bootstrap';
import { leveningStr } from '../../common/helper';


interface IPostProps {
    post?: ArticleType;
    handleBookmark: (post: ArticleType) => void;
    handleRemoveBookmark: (post: ArticleType) => void;
}

const Post: React.FunctionComponent<IPostProps> = ({ post, handleBookmark, handleRemoveBookmark }) => {
    return (
        post?
            <Card className="blog-post-card shadow-sm border-0 mb-3">
                <Card.Body>
                    <Card.Title className="mb-2">
                        <Link className="blog-post-link" to={`/blog/${post.ID}`}>{post.Title}</Link>
                    </Card.Title>
                    <Card.Text className="text-muted mb-3">{leveningStr(post.Body, 220)}...</Card.Text>
                    <div className="d-flex gap-2 flex-wrap">
                        <Link className="btn btn-outline-primary btn-sm" to={`/blog/${post.ID}`}>Read more</Link>
                        {
                            post.Bookmark ?
                                <Button variant="warning" size="sm" onClick={() => handleRemoveBookmark(post)}>Remove bookmark</Button> :
                                <Button variant="outline-warning" size="sm" onClick={() => handleBookmark(post)}>Add bookmark</Button>
                        }
                    </div>
                </Card.Body>
            </Card> : <div></div>
    );
};
export default Post;
